import { defineLeerplusTypes, getDefaultState, ISaveState } from '@gametailors/leerplus';
import { StudioApiDataPackageProvider, StudioDataInstance, StudioDataPackage } from '@gametailors/lp-studio-connector';
import { generateUid } from '@gametailors/web-core/misc';
import { LpActivity, LpMissionInfo, LpSchema } from '../../typings/schema';

export function wrapInMission(activity: LpActivity): LpMissionInfo {
  return {
    uid: generateUid(),
    dataType: 'MissionInfo',
    description: '',
    name: activity.name ?? `Mission for ${activity.dataType} (${activity.uid})`,
    mission: {
      uid: generateUid(),
      dataType: 'Mission',
      activities: [activity],
    },
    onTrigger: [],
  };
}

export interface IRidCodeLeerplusSaveState extends ISaveState {
  mechanics: {
    leeslijst_stopwatch: {
      bestTime: number | null;
      bestAccuracy: number | null;
    };
  };
}

export function getDefaultCodeSave(): IRidCodeLeerplusSaveState {
  return {
    ...getDefaultState(),
    mechanics: {
      leeslijst_stopwatch: {
        bestTime: null,
        bestAccuracy: null,
      },
    },
  };
}

export const LEERPLUS = defineLeerplusTypes<IRidCodeLeerplusSaveState, LpSchema>();

export class ExpandableDataPackageProvider extends StudioApiDataPackageProvider {
  private instances: StudioDataInstance[] = [];

  public include(instances: StudioDataInstance[]): void {
    this.instances.push(...instances);
  }

  override async getDataPackage(): Promise<StudioDataPackage> {
    const basePackage = await super.getDataPackage();
    return {
      ...basePackage,
      instances: [...basePackage.instances, ...this.instances],
    };
  }
}
